<template>
    <div>
        <b-table :items="orders"
                      :fields="fields"
                      small striped>
            
            <template #cell(orderId)="data">
                <copy-to-clipboard :value="data.item.orderId.toString()" /><span class="ml-1">{{ data.item.orderId }}</span>
            </template>

            <template #cell(orderDate)="data">
                <span>{{ moment(data.item.platform.date).format('M/D/YYYY') }}</span>
            </template>

            <template #cell(price)="data">
                <span class="text-success">${{ getPrice(data.item) }}</span>
            </template>

            <template #cell(grade)="data">
                <span>{{ getGrade(data.item) }}</span>
            </template>

            <template #cell(details)="row">
                <b-button size="sm"  @click="row.toggleDetails" class="mr-2" variant="secondary">
                    {{ row.detailsShowing ? 'Hide' : 'Show'}}
                </b-button>
            </template>

            <template #row-details="row">
                <b-card>
                    <order-item :item="getItemFromOrder(row.item)" :hideImages="true" :showSource="true" :showModifiedHistory="true"></order-item>
                </b-card>
            </template>
        </b-table>
    </div>
    
</template>

<script>
    import ordersMixin from "@/api/orders";
    import OrderItem from "../orders/Item";
    import CopyToClipboard from '../CopyToClipboard';

    export default {
        name: "SalesHistory",
        props: [ "item", "orders" ],
        mixins: [ ordersMixin ],
        components: { OrderItem, CopyToClipboard   },
        data() {  
            return {
                fields: [
                    { key: 'orderId', label: 'Order' },
                    { key: 'orderDate', label: 'Date' },
                    { key: 'platform.site', label: 'Platform' },
                    { key: 'customer.fullName', label: 'Name' },
                    { key: 'grade', label: 'Grade' },
                    { key: 'price', label: 'Price' },
                    'details',
                ],
            }
        },
        methods: {
            addRowVariants(orders, itemId) {
                for (let i = 0; i < orders.length; i++) {
                    if (orders[i].location === 'Cancelled' || orders[i].location === 'Returned') {
                        orders[i]._rowVariant = 'danger';
                    }

                    for (let k = 0; k < orders[i].items.length; k++) {
                        if (orders[i].items[k].details.itemId === itemId && orders[i].items[k].status && orders[i].items[k].status.type === 'removed') {
                            orders[i]._rowVariant = 'warning';
                        }
                    }
                }

                return orders;
            },
            getItemFromOrder(order) {
                let details = {};

                order.items.forEach(item => {
                    if (parseInt(item.details.itemId) === parseInt(this.item.itemId)) {
                        details = item.details;
                    }
                });

                return details;
            },
            getPrice(order) {
                let item = this.getItemFromOrder(order);

                return item.listing.price ? item.listing.price : 0;
            },
            getGrade(order) {
                let item = this.getItemFromOrder(order);

                let grade = '';

                item.listing.condition.forEach(c => {
                    if (!c.subject || c.subject === 'item' || c.subject === 'disc') {
                        grade = c.grade;
                    }
                });

                return grade;
            },
        }
    }
</script>

<style scoped>

</style>